import React, { useEffect } from "react"
import {
  IonContent,
  IonHeader,
  IonPage,
  IonButtons,
  IonBackButton,
  IonIcon,
  IonList,
  IonItem,
  IonLabel,
  IonToolbar,
} from "@ionic/react"
import { useDispatch, useSelector } from "react-redux"
import { useHistory, useParams } from "react-router"
import { getDepartment, DEPARTMENT_CLEAR } from "../../redux/actions"
import { callOutline, mailOutline, personOutline } from "ionicons/icons"
import "./AddressBookDetailDepartment.scss"
import { AppState } from "../../global"

const AddressBookDetailDepartment: React.FC = () => {
  let history = useHistory()
  const dispatch = useDispatch()

  const departmentId = useParams<{ departmentId: string }>().departmentId
  const department = useSelector((state: AppState) => state.department)

  useEffect(() => {
    console.log("contactId: ", departmentId)
    departmentId && dispatch(getDepartment(departmentId))
    return () => {
      dispatch({
        type: DEPARTMENT_CLEAR,
        payload: null,
      })
    }
  }, [])

  const getEmployeeHandler = async (id: string) => {
    history.push("/address-book/employee/" + id)
  }

  const renderDepartmentNumber = (
    item: { id?: string; label: string; number: string; note?: string },
    index: number
  ) => (
    <IonItem key={item.id || `${item.label}-${item.number}-${index}`}>
      <IonIcon slot="start" icon={callOutline}></IonIcon>
      <IonLabel className="ion-text-wrap department-number-label">
        <h2>{item.label}:</h2>
        <a href={`tel: ${item.number}`}>{item.number}</a>
        {item.note && <span className="department-number-note">{item.note}</span>}
      </IonLabel>
    </IonItem>
  )

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton defaultHref="/" />
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      {department && (
        <IonContent>
          <div className="ion-text-center ion-margin-bottom">
            <h1>{department?.name}</h1>
          </div>
          <IonList>
            {department.manager && department.manager.last_name.length > 0 && (
              <IonItem>
                <IonIcon slot="start" icon={personOutline}></IonIcon>
                <IonLabel className="ion-text-wrap">
                  <h2>Direttore:</h2>
                  <a
                    onClick={() => {
                      getEmployeeHandler(department!.manager.id)
                    }}
                  >
                    {department!.manager.title} {department!.manager.first_name}{" "}
                    {department!.manager.last_name}
                  </a>
                </IonLabel>
              </IonItem>
            )}

            {department.doctors_office_number &&
              department.doctors_office_number.length > 0 && (
                <IonItem>
                  <IonIcon slot="start" icon={callOutline}></IonIcon>
                  <IonLabel className="ion-text-wrap">
                    <h2>Studio Medici:</h2>
                    {department.doctors_office_number.map(
                      (currNumber, index) => (
                        <a href={`tel: ${currNumber}`}>{currNumber}</a>
                      )
                    )}
                  </IonLabel>
                </IonItem>
              )}

            {department.nurses_office_number &&
              department.nurses_office_number.length > 0 && (
                <IonItem>
                  <IonIcon slot="start" icon={callOutline}></IonIcon>
                  <IonLabel className="ion-text-wrap">
                    <h2>Infermieri:</h2>
                    {department.nurses_office_number.map(
                      (currNumber, index) => (
                        <a href={`tel: ${currNumber}`}>{currNumber}</a>
                      )
                    )}
                  </IonLabel>
                </IonItem>
              )}

            {department.fax_number && department.fax_number.length > 0 && (
              <IonItem>
                <IonIcon slot="start" icon={callOutline}></IonIcon>
                <IonLabel className="ion-text-wrap">
                  <h2>Fax:</h2>
                  {department.fax_number.map((currNumber, index) => (
                    <a href={`tel: ${currNumber}`}>{currNumber} </a>
                  ))}
                </IonLabel>
              </IonItem>
            )}

            {department.structured_doctors &&
              department.structured_doctors.length > 0 && (
                <IonItem>
                  <IonIcon slot="start" icon={personOutline}></IonIcon>
                  <IonLabel className="ion-text-wrap">
                    <h2>Medici Strutturati:</h2>
                    {department.structured_doctors.map((currDoc, index) => (
                      <a
                        onClick={() => {
                          getEmployeeHandler(currDoc.id)
                        }}
                      >
                        {currDoc.title} {currDoc.first_name} {currDoc.last_name}
                      </a>
                    ))}
                  </IonLabel>
                </IonItem>
              )}
            {department.chief_nurse_number &&
              department.chief_nurse_number.length > 0 && (
                <IonItem>
                  <IonIcon slot="start" icon={callOutline}></IonIcon>
                  <IonLabel className="ion-text-wrap">
                    <h2>Caposala:</h2>
                    {department.chief_nurse_number.map((currNumber, index) => (
                      <a href={`tel: ${currNumber}`}>{currNumber} </a>
                    ))}
                  </IonLabel>
                </IonItem>
              )}
            {department.clinic_number &&
              department.clinic_number.length > 0 && (
                <IonItem>
                  <IonIcon slot="start" icon={callOutline}></IonIcon>
                  <IonLabel className="ion-text-wrap">
                    <h2>Ambulatorio:</h2>
                    {department.clinic_number.map((currNumber, index) => (
                      <a href={`tel: ${currNumber}`}>{currNumber} </a>
                    ))}
                  </IonLabel>
                </IonItem>
              )}
            {department.day_hospital_number &&
              department.day_hospital_number.length > 0 && (
                <IonItem>
                  <IonIcon slot="start" icon={callOutline}></IonIcon>
                  <IonLabel className="ion-text-wrap">
                    <h2>Day Hospytal:</h2>
                    {department.day_hospital_number.map((currNumber, index) => (
                      <a href={`tel: ${currNumber}`}>{currNumber} </a>
                    ))}
                  </IonLabel>
                </IonItem>
              )}
            {department.patients_reserved_number &&
              department.patients_reserved_number.length > 0 && (
                <IonItem>
                  <IonIcon slot="start" icon={callOutline}></IonIcon>
                  <IonLabel className="ion-text-wrap">
                    <h2>Telefono dedicato ai pazienti:</h2>
                    {department.patients_reserved_number.map(
                      (currNumber, index) => (
                        <a href={`tel: ${currNumber}`}>{currNumber} </a>
                      )
                    )}
                  </IonLabel>
                </IonItem>
              )}
            {department.available && department.available.length > 0 && (
              <IonItem>
                <IonIcon slot="start" icon={callOutline}></IonIcon>
                <IonLabel className="ion-text-wrap">
                  <h2>Reperibile:</h2>
                  {department.available.map((currNumber, index) => (
                    <a href={`tel: ${currNumber}`}>{currNumber} </a>
                  ))}
                </IonLabel>
              </IonItem>
            )}
            {department.advices && department.advices.length > 0 && (
              <IonItem>
                <IonIcon slot="start" icon={callOutline}></IonIcon>
                <IonLabel className="ion-text-wrap">
                  <h2>Consulenze:</h2>
                  {department.advices.map((currNumber, index) => (
                    <a href={`tel: ${currNumber}`}>{currNumber} </a>
                  ))}
                </IonLabel>
              </IonItem>
            )}
            {department.administrative_office &&
              department.administrative_office.length > 0 && (
                <IonItem>
                  <IonIcon slot="start" icon={callOutline}></IonIcon>
                  <IonLabel className="ion-text-wrap">
                    <h2>Segreteria:</h2>
                    {department.administrative_office.map(
                      (currNumber, index) => (
                        <a href={`tel: ${currNumber}`}>{currNumber} </a>
                      )
                    )}
                  </IonLabel>
                </IonItem>
              )}
            {department.other_numbers &&
              department.other_numbers.length > 0 && (
                <IonItem>
                  <IonIcon slot="start" icon={callOutline}></IonIcon>
                  <IonLabel className="ion-text-wrap">
                    <h2>Altri numeri:</h2>
                    {department.other_numbers.map((currNumber, index) => (
                      <a href={`tel: ${currNumber}`}>{currNumber} </a>
                    ))}
                  </IonLabel>
                </IonItem>
              )}
            {department.numbers && department.numbers.length > 0 &&
              department.numbers.map((departmentNumber, index) =>
                renderDepartmentNumber(departmentNumber, index)
              )}

            {department.mail && department.mail.length > 0 && (
              <IonItem>
                <IonIcon slot="start" icon={mailOutline}></IonIcon>
                <IonLabel className="ion-text-wrap">
                  <h2>Mail:</h2>
                  {department.mail.map((currMail, index) => (
                    <a href={`mailto: ${currMail}`}>{currMail} </a>
                  ))}
                </IonLabel>
              </IonItem>
            )}
          </IonList>
        </IonContent>
      )}
    </IonPage>
  )
}

export default AddressBookDetailDepartment
